{
    "AppMenu_AppsTitle": "Menu",
    "AppMenu_Apps_Reporting": "Analisi",
    "AppMenu_Apps_FastProvisioning": "Provisioning rapido",
    "AppMenu_Apps_Administration": "Amministrazione",
    "AppMenu_Apps_StatusAndTools": "Stato e strumenti",
    "AppMenu_FavouritesTitle": "Preferiti",
    "NAME": "AppMenu",
    "AppMenu_NewUI": "Suite CX",
    "AppMenu_ClassicUI": "Look classico",
    "AppMenu_NewUIBadge": "Nuovo",
    "AppMenu_NewUIInvite_AriaLabel": "Prova CX Suite",
    "AppMenu_NewUIInvite_Heading": "Scopri CX Suite",
    "AppMenu_NewUIInvite_Body": "Una homepage più veloce, report più spaziosi e una navigazione più chiara. Provala: puoi tornare alla versione precedente in qualsiasi momento.",
    "AppMenu_NewUIInvite_Confirm": "Controlla",
    "AppMenu_NewUIInvite_Dismiss": "Non adesso"
}